import React from 'react';
import AwsCredsTable from '../../../components/aws_creds/AwsCredsTable';
import { useParams } from 'react-router-dom';
import { useDeleteDataVendorAwsCredMutation } from '../../../api/dataVendorAwsCredsApiSlice';


const DataVendorCreds = ({ creds=[] }) => {
  const key = useParams()["dataVendorKey"];
  const [ deleteCred ] = useDeleteDataVendorAwsCredMutation()

  return (
    <AwsCredsTable creds={creds} onDelete={(cell) => (deleteCred([key, cell.value]))}/>
  );
}

export default DataVendorCreds;
